import React, { useLayoutEffect, useRef } from "react";
import { Button, Form, Ref, Segment, TextArea } from "semantic-ui-react";
import { Text } from "../../../components/Text";
import { preventOverflowOnTextarea } from "../utils";
type Props = {
  examples: string[];
  updateExample: (index: number, value: string) => void;
  addExample: () => void;
  removeExample: () => void;
  preface: string;
  updatePreface: (value: string) => void;
};

const DEFAULT_PREFACE =
  "These are some examples of texts, follow the same style/tone of voice:";

export const PromptExamplesField: React.FC<Props> = ({
  examples,
  updateExample,
  addExample,
  removeExample,
  preface,
  updatePreface,
}) => {
  const textareaRefs = useRef<HTMLTextAreaElement[]>([]);
  useLayoutEffect(() => {
    textareaRefs.current.forEach((textarea) => {
      if (textarea) {
        preventOverflowOnTextarea(textarea);
      }
    });
  }, []);

  return (
    <Form.Field data-testid="copy-assistant-template-form-prompts-wrapper">
      <label>Add examples</label>
      <Text color="grey" className="descriptive-helper-text">
        Provide example texts to guide the style and tone of voice of the
        generated output. Add or remove example entries with the +/- buttons
        below.
      </Text>
      <Form.Field>
        <label>Examples preface</label>
        <Text color="grey" className="descriptive-helper-text">
          Optional. Sentence shown to the model just before the examples. Leave
          empty to use the default.
        </Text>
        <TextArea
          data-testid="copy-assistant-examples-preface-input"
          style={{ whiteSpace: "pre-wrap" }}
          placeholder={DEFAULT_PREFACE}
          value={preface}
          onChange={(_, { value }): void => {
            updatePreface(value as string);
          }}
        />
      </Form.Field>
      {examples.map((example, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Form.Field key={index} as={Segment}>
          <Form.Field>
            <label>Example {index + 1}</label>
            <Ref innerRef={(el): number => textareaRefs.current.push(el)}>
              <TextArea
                data-testid={`copy-assistant-example-textarea-input-${
                  index + 1
                }`}
                style={{ whiteSpace: "pre-wrap" }}
                placeholder={`Example ${index + 1}`}
                value={example}
                onChange={(_, { value }): void => {
                  updateExample(index, value as string);
                }}
              />
            </Ref>
          </Form.Field>
        </Form.Field>
      ))}
      <Button
        data-testid="copy-assistant-add-example"
        color="red"
        basic
        size="mini"
        icon="add"
        onClick={(): void => addExample()}
      />

      <Button
        data-testid="copy-assistant-remove-example"
        color="red"
        basic
        size="mini"
        icon="minus"
        onClick={(): void => removeExample()}
        disabled={!examples.length}
      />
    </Form.Field>
  );
};
